module.exports = __webpack_public_path__ + "img/06.d38a02e6.png";